import { resolveUrl } from "~/utils/url/urlResolver";

/** Resolve a URL supplied by the asynchronous Bootstrap payload at render time. */
export function resolveBootstrapUrl(url?: string): string {
  return resolveUrl(url ?? "");
}
